import { useNavigate } from 'react-router-dom';

import { colors } from 'inpock-ui-react/dist/src/color';
import { SmallText2 } from 'inpock-ui-react';

import { ProductMarketInfo } from '@/apis';
import { Icon } from '@/components';
import { thumbnail } from '@/utils';
import { useCartCountQuery } from '@/hooks';

import * as S from './styled';

interface NavigationProps {
  seller?: string;
  sellerId?: number;
  brandName?: string;
  marketInfo?: Omit<ProductMarketInfo, 'market_id'>;
  withCategory?: boolean;
  borderBottom?: boolean;
  onBackIcon?: boolean;
  hidden?: boolean;
  onClickShare?: () => void;
  version?: string;
}

export function Navigation(props: NavigationProps) {
  const navigate = useNavigate();
  const { data: cartCountData } = useCartCountQuery();

  const { REACT_APP_LINK_CLIENT_URL } = process.env;
  const onRouteMenu = () => (window.location.href = `${REACT_APP_LINK_CLIENT_URL}/customer/login`);
  const onClickCart = () => navigate('/cart');
  const onRouteMarket = () =>
    navigate(props.version ? `/${props.version}/${props.seller}` : `/${props.seller}`);

  return (
    <S.Wrapper>
      <S.Container className={props.hidden ? 'hidden' : ''} borderBottom={props.borderBottom}>
        <S.Left>
          <Icon
            icon="ArrowLeft"
            size={20}
            color={colors.black}
            onClick={() => window.history.back()}
          />
          <div className="market-title" style={{ cursor: 'pointer' }} onClick={onRouteMarket}>
            {props.marketInfo?.logo_type === 'text' ? (
              <S.MarketLogoText>{props.marketInfo?.logo_text}</S.MarketLogoText>
            ) : (
              <S.MarketLogoImage
                src={thumbnail.small(props.marketInfo?.logo_image || '')}
                alt="market-logo"
              />
            )}
          </div>
        </S.Left>
        <S.Right>
          <Icon icon="Share" size={12} onClick={props.onClickShare} />
          {props.version === 'v2' && (
            <S.BtnCartContainer onClick={onClickCart}>
              <S.BtnCart />
              <S.CartCount>
                <SmallText2 className="text-white">{cartCountData?.cart_count || 0}</SmallText2>
              </S.CartCount>
            </S.BtnCartContainer>
          )}
          <Icon sx={{ marginTop: '2px' }} icon="Menu" size={12} onClick={onRouteMenu} />
        </S.Right>
      </S.Container>
    </S.Wrapper>
  );
}
